import React from 'react';
import Seo from '../../components/Seo';
import { countryCards } from '../../content/siteContent';

function Countries() {
  return (
    <main>
      <Seo
        title="Study Destinations | Vedanskrix College Admission"
        description="Explore study destination guidance for the UK, USA, Canada, Australia, and the Netherlands with Vedanskrix College Admission."
        keywords={['study destinations', 'UK admission guidance', 'USA college admission', 'Canada student guidance']}
      />

      <section className="ca-page-hero ca-page-hero--dark">
        <div className="ca-container">
          <span className="ca-eyebrow">Country Options</span>
          <h1>Choose a destination that fits your academics, budget, and future plans.</h1>
          <p>
            We help students compare countries by education style, admission requirements,
            affordability, and overall fit instead of following a one-size-fits-all path.
          </p>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-country-grid ca-country-grid--wide">
          {countryCards.map((country) => (
            <article key={country.name} className="ca-country-card ca-country-card--wide">
              <span>{country.code}</span>
              <div>
                <h2>{country.name}</h2>
                <p>{country.focus}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Countries;
